import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import HometaxTimeoutError from '@/components/tax-refund/common/view/ErrorView/HometaxTimeoutError';
import { COMMON_PATHS, INDIVIDUAL_PATHS } from '@/lib/constants/paths';

const ErrorPage = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const handleClickExit = () => {
    sendClickEvent('indis-lookup_error-timeout_close');

    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  const handleRetry = () => {
    sendClickEvent('indis-lookup_error-timeout_retry');
    router.replace({
      pathname: `${INDIVIDUAL_PATHS.개인수집및조회}`,
      query: { type: 'indis' }
    });
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="indis-lookup_error-timeout" />
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <HometaxTimeoutError onPrimaryButtonClick={handleRetry} />
      </Layout>
    </AuthGuard>
  );
};

export default ErrorPage;
